export const FETCH_LIST_ATTENDER_REQUEST= "FETCH_LIST_ATTENDER_REQUEST";
export const FETCH_LIST_ATTENDER_SUCCESS= "FETCH_LIST_ATTENDER_SUCCESS";
export const FETCH_LIST_ATTENDER_FAILURE= "FETCH_LIST_ATTENDER_FAILURE";


export const FETCH_ATTENDER_REQUEST= "FETCH_ATTENDER_REQUEST";
export const FETCH_ATTENDER_SUCCESS= "FETCH_ATTENDER_SUCCESS";
export const FETCH_ATTENDER_FAILURE= "FETCH_ATTENDER_FAILURE";


export const ADD_ATTENDER_REQUEST = "ADD_ATTENDER_REQUEST";
export const ADD_ATTENDER_SUCCESS = "ADD_ATTENDER_SUCCESS";
export const ADD_ATTENDER_FAILURE = "ADD_ATTENDER_FAILURE";


export const UPDATE_ATTENDER_REQUEST= "UPDATE_ATTENDER_REQUEST";
export const UPDATE_ATTENDER_SUCCESS= "UPDATE_ATTENDER_SUCCESS";
export const UPDATE_ATTENDER_FAILURE= "UPDATE_ATTENDER_FAILURE";

export const DELETE_ATTENDER_REQUEST= "DELETE_ATTENDER_REQUEST";
export const DELETE_ATTENDER_SUCCESS= "DELETE_ATTENDER_SUCCESS";
export const DELETE_ATTENDER_FAILURE= "DELETE_ATTENDER_FAILURE";


export const RESET_CURRENT_ATTENDER= "RESET_CURRENT_ATTENDER";

export const HISTORY_ATTENDER_REQUEST="HISTORY_ATTENDER_REQUEST";
export const HISTORY_ATTENDER_SUCCESS="HISTORY_ATTENDER_SUCCESS";
export const HISTORY_ATTENDER_FAILURE="HISTORY_ATTENDER_FAILURE";